import styled from 'styled-components';
import { Spinner2 } from '@styled-icons/evil/Spinner2';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Spinner = styled(Spinner2)`
  width: 2.5rem;
  color: ${({ theme }) => theme.colors.blue};
  animation: rotation 3s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
